import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemContentBase } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-base';

@Component({
    selector: 'fi-news-feed-item-content-form-reminder',
    template: `
        <div class="NewsFeedContent">
            <div class="NewsFeedContentHeader">
                {{ 'form.reminder_feed_text' | fiAppText }}
            </div>

            <a
                class="NewsFeedItem-FormReadMore BrandedColor"
                [fiStateSref]="FiStateNames.Form.View"
                [fiStateSrefParams]="{ id: newsItem.Content.FormId }"
            >
                {{ 'form.feed_text2' | fiAppText }}&nbsp;{{ getPreferredContentLabelName(newsItem.Content.Names) }}
            </a>
        </div>
    `,
    styleUrls: ['./news-feed-item-content-form-reminder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemContentFormReminderComponent extends NewsFeedItemContentBase {}
